import { t } from 'i18next';
import { gnrPeriodEnum, gnrStateEnum } from '../enums';

export const gnrPeriodEnumLabels: Record<number, string> = {
    [gnrPeriodEnum.VERY_EARLY_MORNING]: 'veryEarlyMorning',
    [gnrPeriodEnum.MORNING]: 'morning',
    [gnrPeriodEnum.FULL_DAY]: 'allDay',
    [gnrPeriodEnum.AFTERNOON]: 'earlyAfternoon',
};

export const gnrStateEnumLabels: Record<number, string> = {
    [gnrStateEnum.REQUESTED]: 'requested',
    [gnrStateEnum.IN_PROGRESS]: 'planned',
    [gnrStateEnum.DELIVERED]: 'delivered',
    [gnrStateEnum.CANCELED]: 'canceled',
    [gnrStateEnum.ARCHIVED]: 'archived',
};

export const getGnrPeriodLabel = (period?: number): string => {
    return period !== undefined && gnrPeriodEnumLabels[period] ? t(gnrPeriodEnumLabels[period]) : '';
};

export const getGnrStateLabel = (state?: number): string => {
    return state !== undefined && gnrStateEnumLabels[state] ? t(gnrStateEnumLabels[state]) : '';
};
